import React from "react";
import { Box } from "@mui/material";
import SabiasQue from "../SabiasQue";

// Template27: Página Día 3 - Arashiyama (Kioto)
// Contenido desde page.texts, page.images y page.canvasImages (servidor).
const Template27 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
	updatePage,
}) => {
	const isSmallScreen = window.innerWidth <= 600;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found && found.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found && found.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const parseSabiasQueItem = (html) => {
		if (!html) return null;
		const parser = new DOMParser();
		const doc = parser.parseFromString(html, "text/html");
		const p = doc.querySelector("p");
		if (!p) return null;
		const text = (p.textContent ?? p.innerText ?? "").trim();
		const emojiMatch = text.match(/^([^\s]+)\s+(.*)/s);
		if (emojiMatch)
			return { icono: emojiMatch[1], texto: emojiMatch[2].trim() };
		return null;
	};

	const headerText = page?.texts?.[0]?.content;
	const heroTitle = page?.texts?.[1]?.content;
	const introText = page?.texts?.[2]?.content;
	const puenteTitle = page?.texts?.[3]?.content;
	const puenteText = page?.texts?.[4]?.content;
	const calleText = page?.texts?.[5]?.content;
	const bosqueTitle = page?.texts?.[6]?.content;
	const bosqueText = page?.texts?.[7]?.content;
	const sabiasQueBosque = parseSabiasQueItem(page?.texts?.[8]?.content);
	const rioTitle = page?.texts?.[9]?.content;
	const rioText = page?.texts?.[10]?.content;
	const transporteTitle = page?.texts?.[11]?.content;
	const transporteText = page?.texts?.[12]?.content;
	const reservaText = page?.texts?.[13]?.content;

	const arashiyamaImage = getImageSrc("arashiyama-main");
	const bosqueImage = getImageSrc("bosque");
	const logoImage = getCanvasImageUrl("logo");
	const arashiyamaSticker = getCanvasImageUrl("arashiyama-sticker");
	const bosqueBambuSticker = getCanvasImageUrl("bosque-bambu-sticker");

	const contentColor = textColor || "#444";

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				width: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *:not([data-template-header])": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
					color: "inherit",
				},
				"& p": {
					marginTop: "0px !important",
					marginBottom: "0px !important",
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: headerBackgroundColor || "#5ba374",
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
					fontSize: "14px",
					fontWeight: 800,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 9999,
				}}
			>
				{headerText}
				{logoImage && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			<Box data-block-id="image-0" sx={{ position: "relative" }}>
				{arashiyamaImage && (
					<Box
						component="img"
						src={arashiyamaImage}
						alt="Arashiyama"
						sx={{
							width: "100%",
							height: 194,
							objectFit: "cover",
						}}
					/>
				)}
				{arashiyamaSticker && (
					<Box
						component="img"
						src={arashiyamaSticker}
						alt="Arashiyama"
						sx={{
							width: "100px",
							position: "absolute",
							bottom: "55px",
							left: "21px",
						}}
					/>
				)}
				{heroTitle && (
					<Box
						component="h1"
						sx={{
							fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
							fontSize: "32px",
							textAlign: "center",
							position: "absolute",
							bottom: "0",
							margin: "10px",
							left: "20px",
							color: "#fff",
							textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
						}}
					>
						{heroTitle}
					</Box>
				)}
			</Box>

			<Box data-block-id="text-1" sx={{ padding: "10px 12px 0px", marginTop: "-5px" }}>
				{introText && (
					<Box
						component="p"
						sx={{
							fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
							fontSize: "13px",
							color: "#333",
							margin: "0 !important",
							padding: 0,
							marginBottom: "0px !important",
						}}
					>
						{introText}
					</Box>
				)}

				<Box
					sx={{
						flex: 1,
						display: "flex",
						flexDirection: "column",
						gap: "16px",
						position: "relative",
					}}
				>
					{(puenteTitle || puenteText) && (
						<Box
							sx={{
								display: "flex",
								gap: "20px",
								alignItems: "flex-start",
							}}
						>
							<Box>
								{puenteTitle && (
									<Box
										component="h3"
										sx={{
											fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
											marginBottom: "4px",
											fontSize: "14px",
											fontWeight: 700,
											textTransform: "uppercase",
										}}
									>
										{puenteTitle}
									</Box>
								)}
								{puenteText && (
									<Box
										component="p"
										sx={{
											fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
											fontSize: "13px",
											color: contentColor,
											margin: "0 !important",
											marginBottom: "0px !important",
										}}
									>
										{puenteText}
									</Box>
								)}
							</Box>
							{calleText && (
								<Box sx={{ position: "relative" }}>
									<Box
										sx={{
											backgroundColor: "#5ba374",
											border: "6px solid #417754",
											padding: "16px",
											fontSize: "10px",
											borderRadius: "50%",
											width: "130px",
											height: "130px",
											color: "#fff!important",
											textAlign: "center",
											display: "flex",
											justifyContent: "center",
											flexDirection: "column",
											alignItems: "center",
											fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
											marginTop: isSmallScreen ? "12px" : 0,
										}}
									>
										{calleText}
									</Box>
								</Box>
							)}
						</Box>
					)}

					<Box
						sx={{
							display: "flex",
							gap: "20px",
							alignItems: "flex-start",
							marginTop: isSmallScreen ? 0 : "-15px",
							position: "relative",
							marginBottom: isSmallScreen ? "100px" : 0,
						}}
					>
						{bosqueImage && (
							<Box
								component="img"
								src={bosqueImage}
								alt="Bosque"
								sx={{
									width: "40%",
									borderRadius: "12px",
									objectFit: "cover",
									height: "110px",
								}}
							/>
						)}
						<Box sx={{ width: "60%", position: "relative" }}>
							{sabiasQueBosque && (
								<Box sx={{ position: "absolute", top: "-35px", right: "65%" }}>
									<SabiasQue
										icono={sabiasQueBosque.icono}
										texto={sabiasQueBosque.texto}
									/>
								</Box>
							)}
							{bosqueTitle && (
								<Box
									component="h3"
									sx={{
										fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
										marginBottom: "4px",
										fontSize: "14px",
										fontWeight: 700,
										textTransform: "uppercase",
										marginTop: "8px",
									}}
								>
									{bosqueTitle}
								</Box>
							)}
							{bosqueText && (
								<Box
									component="p"
									sx={{
										fontSize: "13px",
										color: contentColor,
										fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
										margin: "0 !important",
										marginBottom: "0px !important",
									}}
								>
									{bosqueText}
								</Box>
							)}
						</Box>
					</Box>

					<Box sx={{ position: "relative" }}>
						{isSmallScreen && reservaText && (
							<Box
								sx={{
									position: "absolute",
									top: "-110px",
									left: "50px",
									backgroundColor: "#fff8db",
									border: "2px solid #f5c400",
									borderRadius: "16px 16px 16px 0px",
									padding: "10px 12px",
									fontSize: "11px",
									fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
									color: contentColor,
									boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
									maxWidth: "200px",
									zIndex: 100,
								}}
								dangerouslySetInnerHTML={{ __html: reservaText }}
							/>
						)}
						{isSmallScreen && bosqueBambuSticker && (
							<Box
								component="img"
								src={bosqueBambuSticker}
								alt="BosqueBambu"
								sx={{
									width: "100px",
									position: "absolute",
									top: "-100px",
									left: "-30px",
								}}
							/>
						)}
						{rioTitle && (
							<Box
								component="h3"
								sx={{
									fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
									marginBottom: "4px",
									fontSize: "14px",
									fontWeight: 700,
									textTransform: "uppercase",
									marginTop: isSmallScreen ? 0 : "8px",
								}}
							>
								{rioTitle}
							</Box>
						)}
						{rioText && (
							<Box
								component="p"
								sx={{
									fontSize: "13px",
									fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
									margin: "0 !important",
									marginBottom: "0px !important",
								}}
							>
								{rioText}
							</Box>
						)}
					</Box>

					{(transporteTitle || transporteText) && (
						<Box
							sx={{
								backgroundColor: "#d9e6de",
								border: "3px solid #5ba374",
								borderRadius: "12px",
								padding: "16px 20px",
								fontSize: "12px",
								fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
								color: "#333",
								width: "100%",
								position: "relative",
								marginBottom: isSmallScreen ? "4px" : 0,
							}}
						>
							{!isSmallScreen && bosqueBambuSticker && (
								<Box
									component="img"
									src={bosqueBambuSticker}
									alt="BosqueBambu"
									sx={{
										width: "100px",
										position: "absolute",
										top: "-100px",
										right: "-10px",
									}}
								/>
							)}
							{!isSmallScreen && reservaText && (
								<Box
									sx={{
										position: "absolute",
										top: "-100px",
										right: "70px",
										backgroundColor: "#fff8db",
										border: "2px solid #f5c400",
										borderRadius: "16px 16px 0px 16px",
										padding: "10px 12px",
										fontSize: "11px",
										fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
										color: contentColor,
										boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
										maxWidth: "220px",
									}}
									dangerouslySetInnerHTML={{ __html: reservaText }}
								/>
							)}
							{transporteTitle && (
								<Box
									component="h4"
									sx={{
										margin: 0,
										marginBottom: "8px",
										fontSize: "13px",
										fontWeight: 700,
										display: "flex",
										alignItems: "center",
										gap: "6px",
										color: "#5ba374!important",
										textTransform: "uppercase",
									}}
								>
									{transporteTitle}
								</Box>
							)}
							{transporteText && (
								<Box
									component="div"
									sx={{
										"& ul": {
											paddingLeft: "20px",
											margin: 0,
											lineHeight: 1.5,
										},
										"& li": {
											marginBottom: "0px",
										},
									}}
									dangerouslySetInnerHTML={{ __html: transporteText }}
								/>
							)}
						</Box>
					)}
				</Box>
			</Box>
		</Box>
	);
};

Template27.thumbnail = "/images/template-1.png";

export default Template27;
